import { render, staticRenderFns } from "./MemberMainDialog.vue?vue&type=template&id=79770209&scoped=true&"
import script from "./MemberMainDialog.vue?vue&type=script&lang=js&"
export * from "./MemberMainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79770209",
  null
  
)

export default component.exports